import React from "react";
import { BallTriangle } from "react-loader-spinner";
import { useLoading } from "./LoadingContext";
import zIndex from "@mui/material/styles/zIndex";

function Loader() {
  const { loading } = useLoading();
  debugger;
  if (loading === false) return null; // Don't render if not loading

  return (
    <div
      style={{
        inlineSize: "100%",
        blockSize: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        backgroundColor: "rgb(0 0 0 / 17%)",
      }}
    >
      <div className="loader"></div>
    </div>
  );
}

export default Loader;
